<!-- eslint-disable @angular-eslint/template/elements-content -->
<div class="color-picker" [ngClass]="{'no-menu': noMenu}">
  <ng-container *ngIf="!noMenu; else picker">
    <button
      class="color-picker__tool-btn"
      [ngStyle]="{'background-color': color ? color : defaultColor}"
      [matMenuTriggerFor]="menu"></button>
    <div *ngIf="text" class="color-picker__text">
      {{ text | translate }}
    </div>
    <mat-menu [overlapTrigger]="false" #menu="matMenu">
      <ng-container *ngTemplateOutlet="picker"></ng-container>
    </mat-menu>
  </ng-container>

  <ng-template #picker>
    <div class="palette" [ngClass]="{palette__menu: !noMenu}">
      <span
        class="color-picker__color-cell"
        *ngFor="let color of palette"
        appColorClick
        (colorPicked)="throwUp($event)"
        [ngStyle]="{background: '#' + color}"></span>
    </div>
  </ng-template>
</div>
